/* =============================================================
   IceFishAC — Cinematic Interaction Engine
   Scroll reveals, parallax depth, premium microinteractions
   ============================================================= */

(function() {
  'use strict';

  /* ── Scroll Reveal ── */
  var revealEls = document.querySelectorAll('.ic-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ic-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    revealEls.forEach(function(el) {
      revealObserver.observe(el);
    });
  }

  /* ── Parallax Depth ── */
  var parallaxEls = document.querySelectorAll('[data-ic-parallax]');
  if (parallaxEls.length) {
    var ticking = false;
    function updateParallax() {
      var scrollY = window.pageYOffset;
      parallaxEls.forEach(function(el) {
        var speed = parseFloat(el.dataset.icParallax) || 0.15;
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var offset = (center - window.innerHeight / 2) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Magnetic Button Hover ── */
  var magneticBtns = document.querySelectorAll('.ic-btn--primary, .ic-quote-btn');
  magneticBtns.forEach(function(btn) {
    btn.addEventListener('mousemove', function(e) {
      var rect = btn.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = 'translateY(-3px) translate(' + (x * 0.15) + 'px, ' + (y * 0.15) + 'px)';
    });
    btn.addEventListener('mouseleave', function() {
      btn.style.transform = '';
    });
  });

  /* ── Ambient Glow Cursor Tracking ── */
  document.querySelectorAll('.ic-glass, .ic-testimonial-card, .ic-use-case-card, .ic-stat-item, .collection-card, .product-grid__card').forEach(function(card) {
    card.addEventListener('mousemove', function(e) {
      var rect = card.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
      var y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
      card.style.setProperty('--mouse-x', x + '%');
      card.style.setProperty('--mouse-y', y + '%');
      if (!card.querySelector('.ic-cursor-glow')) {
        var glow = document.createElement('div');
        glow.className = 'ic-cursor-glow';
        glow.style.cssText = 'position:absolute;inset:0;opacity:0;transition:opacity 0.3s ease;pointer-events:none;border-radius:inherit;background:radial-gradient(600px circle at var(--mouse-x) var(--mouse-y),rgba(0,102,204,0.04),transparent 40%);z-index:0;';
        card.style.position = 'relative';
        card.appendChild(glow);
      }
      var glow = card.querySelector('.ic-cursor-glow');
      if (glow) glow.style.opacity = '1';
    });
    card.addEventListener('mouseleave', function() {
      var glow = card.querySelector('.ic-cursor-glow');
      if (glow) glow.style.opacity = '0';
    });
  });

})();
